import { useMemo } from 'react';
import { withLanguageContext } from '@/context';

//* Style
import ProductBadgesStyle from './style';

const ProductBadges = ({ badges = [], stock_status, className = '', translate }) => {
	//! Calculate product badges from backend + out of stock
	const displayBadges = useMemo(() => {
		const badgeList = [];

		// Add badges from backend
		if (badges && Array.isArray(badges)) {
			badges.forEach((badge) => {
				if (badge && badge.name) {
					// Map badge name to badge type (slug-based or name-based)
					const badgeType = badge.slug || badge.name.toLowerCase().replace(/\s+/g, '-');
					badgeList.push({
						label: badge.name,
						type: badgeType,
						color: badge.color,
					});
				}
			});
		}

		// Out of stock badge - only this one depends on stock_status
		if (stock_status === 'outofstock') {
			badgeList.push({ label: 'outOfStock', type: 'out-of-stock', color: 'Outofstock' });
		}

		return badgeList;
	}, [badges, stock_status]);

	if (displayBadges.length === 0) {
		return null;
	}

	return (
		<ProductBadgesStyle className={className}>
			{displayBadges.map((badge, index) => {
				return (
					<span
						key={index}
						className={`badge ${badge.color}`}
					>
						{translate(badge.label)}
					</span>
				);
			})}
		</ProductBadgesStyle>
	);
};

export default withLanguageContext(ProductBadges, ['translate']);
